import React from "react";
import FormElement from "./FormElement";

class Checkbox extends FormElement {

    render() {
        return (
            <div className="form-check">
                <input type="checkbox"
                       name={this.props.name}
                       id={this.props.name}
                       className="form-check-input"
                       onChange={(e) => {
                           this.checkValid(e);
                           this.props.handleChange(e);
                       }}
                       required={this.props.required}
                       checked={this.props.checked}
                />
                <label className="form-check-label" htmlFor={this.props.name}>
                    {this.props.label}
                </label>
            </div>
        );
    }
}

export default Checkbox;
